<template>
    <div data-testid="vue-route-not-found">
        404
    </div>
</template>
